import { MediaFileTypes } from '@shared/config/media';
import { EXTENSION_ONLY_VIDEO_EXTENSIONS, IMAGE_EXTENSIONS, VIDEO_EXTENSIONS } from './consts';
import { MediaPreviewInput, MediaPreviewKind } from './types';

export const getMediaPreviewKind = ({ type, extension }: MediaPreviewInput): MediaPreviewKind | undefined => {
  const normalizedExtension = extension?.toLowerCase() ?? '';
  const isImageExtension = IMAGE_EXTENSIONS.has(normalizedExtension);
  const isVideoExtension = VIDEO_EXTENSIONS.has(normalizedExtension);

  if (type === MediaFileTypes.IMAGE || type === MediaFileTypes.IMAGE_PROMO) {
    return isVideoExtension ? undefined : 'image';
  }

  if (type === MediaFileTypes.VIDEO || type === MediaFileTypes.VIDEO_PROMO) {
    return isImageExtension ? undefined : 'video';
  }

  if (type != null) return undefined;
  if (isImageExtension) return 'image';
  if (EXTENSION_ONLY_VIDEO_EXTENSIONS.has(normalizedExtension)) return 'video';

  return undefined;
};
